export enum BonusSubTypeEnum {
    FromGGR = 1,
    FromDeposit = 2,
    OverallNetwork = 3
}
